const selectors = {
  layout: 'body',
}

const classes = {
  overlay: 'overlay',
}

const elements = {
  layout: null,
}

const overlay = () => {
  elements.layout = document.querySelector(selectors.layout)

  return {
    showOverlay: (overlayInitiator = '') => {
      window.overlayInitiator = overlayInitiator
      elements.layout?.classList.add(classes.overlay)
    },
    hideOverlay: () => {
      window.overlayInitiator = ''
      elements.layout?.classList.remove(classes.overlay)
    },
  }
}

export default overlay
